module.exports = __webpack_public_path__ + "static/media/microphone-alt.31b090e6.svg";